import * as React from 'react';

function CloudDownloadIcon (props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M6.66556 13.3339C5.62636 13.3346 4.62441 12.947 3.8563 12.247C3.08818 11.547 2.60936 10.5853 2.51377 9.55052C2.41818 8.51572 2.71272 7.48256 3.33961 6.65374C3.9665 5.82492 4.88048 5.26027 5.90223 5.07058C6.08169 4.11531 6.58935 3.25278 7.33741 2.63217C8.08548 2.01155 9.02691 1.67188 9.99889 1.67188C10.9709 1.67188 11.9123 2.01155 12.6604 2.63217C13.4084 3.25278 13.9161 4.11531 14.0956 5.07058C15.1139 5.26413 16.0236 5.83014 16.6471 6.65818C17.2706 7.48622 17.5633 8.51687 17.4679 9.54903C17.3726 10.5812 16.8961 11.5408 16.1314 12.2406C15.3667 12.9404 14.3688 13.3302 13.3322 13.3339M7.49889 15.8339L9.99889 18.3339M9.99889 18.3339L12.4989 15.8339M9.99889 18.3339V8.33392"
                stroke="#272560"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default CloudDownloadIcon;
